import { apiURL, axiosInstance } from 'constants/config';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  loadPaymentsRequested,
  loadPaymentsSuccess,
  loadPaymentsFail,
  loadPaymentBillRequested,
  loadPaymentBillSuccess,
  loadPaymentBillFail,
  storePaymentRequested,
  storePaymentSuccess,
  storePaymentFail,
  loadBillInfoRequested,
  loadBillInfoSuccess,
  loadBillInfoFail,
  storeAutoUpdatePaymentRequested,
  storeAutoUpdatePaymentSuccess,
  storeAutoUpdatePaymentFail,
  loadAutoUpdatePaymentRequested,
  loadAutoUpdatePaymentSuccess,
  loadAutoUpdatePaymentFail,
  loadBillInfoByDateRequested,
  loadBillInfoByDateSuccess,
  loadBillInfoByDateFail,
} from './paymentSlice';
import toast from 'react-hot-toast';
import { loadCustomerEffect } from 'store/customers/sagas';
import { loadCustomerActivityLogsByWeeklyEffect, loadCustomerActivityLogsEffect } from 'store/reports/sagas';
import moment from 'moment';

export function* loadPaymentsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/payments?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload.page
      }&PaginationOption.PageSize=${action.payload.perPage}&reference=${
        action.payload?.filters?.reference ?? ''
      }`
    );
    yield put(loadPaymentsSuccess(data));
  } catch (error: any) {
    yield put(loadPaymentsFail(error.message));
  }
}

export function* loadPaymentBillEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/payments/bill?reference=${action.payload}`
    );
    yield put(loadPaymentBillSuccess(data));
  } catch (error: any) {
    yield put(loadPaymentBillFail(error.message));
  }
}

export function* storePaymentEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const today = moment.utc().format('YYYY-MM-DD');
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/payments`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storePaymentSuccess(data));
      yield call(loadCustomerEffect, {
        payload: { reference: action?.payload?.customerReference },
        type: "",
      });
      yield call(loadBillInfoEffect, {
        payload: action?.payload?.customerReference,
        type: '',
      });
      yield call(loadPaymentBillEffect, {
        payload: action?.payload?.customerReference,
        type: '',
      });
      // yield call(loadCustomerActivityLogsEffect, {
      //   payload: {
      //     ids: [data?.result],
      //     startDate: null,
      //     endDate: today,
      //     isDetailBill: false,
      //   },
      //   type: '',
      // });
      yield call(loadCustomerActivityLogsByWeeklyEffect, {
        payload: {
          ids: [data?.result],
          startDate: null,
          endDate: today,
          isDetailBill: false,
        },
        type: '',
      });
      toast.success('Payment successfully added.');
    } else {
      yield put(storePaymentFail(data));
      toast.error('Payment was failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storePaymentFail(error.message));
  }
}

export function* loadBillInfoEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/payments/billinfo?reference=${action.payload}`
    );
    if (data?.succeeded) {
      yield put(loadBillInfoSuccess(data));
    }
  } catch (error: any) {
    yield put(loadBillInfoFail(error.message));
  }
}

export function* storeAutoUpdatePaymentEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.post, `${apiURL}/daily-update`);
    yield put(storeAutoUpdatePaymentSuccess(data));
    yield call(loadAutoUpdatePaymentEffect, {
      payload: {},
      type: '',
    });
    toast.success(data?.result);
  } catch (error: any) {
    yield put(storeAutoUpdatePaymentFail(error.message));
  }
}

export function* loadAutoUpdatePaymentEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/auto-payment-update-info`
    );
    if (data?.succeeded) {
      yield put(loadAutoUpdatePaymentSuccess(data));
    }
  } catch (error: any) {
    yield put(loadAutoUpdatePaymentFail(error.message));
  }
}

export function* loadBillInfoByDateEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/payments/billinfobydate?reference=${action.payload.reference}&date=${action.payload.date}`
    );
    if (data?.succeeded) {
      yield put(loadBillInfoByDateSuccess(data));
    }
  } catch (error: any) {
    yield put(loadBillInfoByDateFail(error.message));
  }
}

export function* paymentsSaga(): Generator<any, void, any> {
  yield takeEvery(loadPaymentsRequested, loadPaymentsEffect);
  yield takeEvery(loadPaymentBillRequested, loadPaymentBillEffect);
  yield takeEvery(storePaymentRequested, storePaymentEffect);
  yield takeEvery(loadBillInfoRequested, loadBillInfoEffect);
  yield takeEvery(
    storeAutoUpdatePaymentRequested,
    storeAutoUpdatePaymentEffect
  );
  yield takeEvery(loadAutoUpdatePaymentRequested, loadAutoUpdatePaymentEffect);
  yield takeEvery(loadBillInfoByDateRequested, loadBillInfoByDateEffect);
}
